import { useEffect, useMemo, useState } from 'react';

const useSelect = ({
  selectionEnabled,
  selected,
  onSelectionChange,
  onRowSelect,
  identifierColumn,
  itemsInPage,
}) => {
  const [allSelected, setAllSelected] = useState(false);

  useEffect(() => {
    if (!selectionEnabled) {
      setAllSelected(false);
    }
  }, [selectionEnabled]);

  const selectedInPage = useMemo(() => {
    if (itemsInPage && itemsInPage.length > 0) {
      return itemsInPage.filter((item) => selected.some((s) => s[identifierColumn] === item[identifierColumn]));
    }
    return [];
  }, [itemsInPage, selected, identifierColumn]);

  useEffect(() => {
    if (selectedInPage && selectedInPage.length > 0) {
      setAllSelected(selectedInPage.length === itemsInPage.length);
    } else {
      setAllSelected(false);
    }
  }, [selectedInPage, itemsInPage]);

  const onItemSelectHandler = (item) => ({ value }) => {
    let updated = selected;
    if (value) {
      updated = [...updated, item];
    } else {
      updated = updated.filter((u) => u[identifierColumn] !== item[identifierColumn]);
    }
    if (onSelectionChange) {
      onSelectionChange(updated);
    }
  };

  const onRowSelectHandler = (item, e) => {
    if (selectionEnabled) {
      onItemSelectHandler(item)({ value: !selected.some((s) => s[identifierColumn] === item[identifierColumn]) });
    }
    if (onRowSelect) {
      onRowSelect(item, e);
    }
  };

  const onHeaderSelectionChange = (event) => {
    setAllSelected((prev) => !prev);

    const checkboxElement = event?.syntheticEvent?.target;
    const checked = checkboxElement ? checkboxElement.checked : !allSelected;
    let updated = selected;
    if (checked) {
      // only change items which are in the current page
      updated = [...updated, ...itemsInPage.filter((item) => !updated.some((s) => s[identifierColumn] === item[identifierColumn]))];
    } else {
      updated = updated.filter((u) => !itemsInPage.some((item) => item[identifierColumn] === u[identifierColumn]));
    }
    if (onSelectionChange) {
      onSelectionChange(updated);
    }
  };

  return {
    allSelected,
    onItemSelectHandler,
    onRowSelectHandler,
    onHeaderSelectionChange,
  };
};

export default useSelect;
